(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tab-actions', {
            parent: 'management',
            url: '/tab-actions?sort&search',
            data: {
                authorities: ['ROLE_DOMAIN_USER'],
                pageTitle: 'jotApp.tabActions.home.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/tab-actions/tab-actions.html',
                    controller: 'TabActionsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: [],
                    squash: true
                },
                search: {
                    value: '',
                    squash: true
                },
                predicates : {}
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicates : $stateParams.predicates,
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tabActions');
                    $translatePartialLoader.addPart('tabDeviceReleases');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tab-actions-detail', {
            parent: 'tab-actions',
            url: '/tab-actions/{id}',
            data: {
                authorities: ['ROLE_DOMAIN_USER'],
                pageTitle: 'jotApp.tabActions.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/tab-actions/tab-actions-detail.html',
                    controller: 'TabActionsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tabActions');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TabActions', function($stateParams, TabActions) {
                    return TabActions.get({id : $stateParams.id});
                }]
            }
        })
        .state('tab-actions.delete', {
            parent: 'tab-actions',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_TECH']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tab-actions/tab-actions-delete-dialog.html',
                    controller: 'TabActionsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TabActions', function(TabActions) {
                            return TabActions.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('tab-actions', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
